
import { AgTableClient } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Tag, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

const PreviousExport = () => {
  const [rowData, setRowData] = useState<any[]>([]); // ✅ dynamic row data

  const COLUMN_DEFS = [
    {
      headerName: "File Name",
      field: "report_name",
      filter: "agTextColumnFilter",
      width: 200,
    },
    {
      headerName: "Type",
      field: "type",
      width: 200,
      cellRenderer: (params: any) => {
        const values = Array.isArray(params.value) ? params.value : [params.value];

        return (
          <>
            {values.map((val: string, idx: number) => {
              let color = "";
              if (val === "Transaction") color = "yellow"; 
              if (val === "Application") color = "green";
              if (val === "Entities") color = "blue";

              return (
                <Tag color={color} key={idx} style={{ marginRight: 4 ,display:'flex', gap:'5px'}}>
                  {val}
                </Tag>
              );
            })}
          </>
        );
      },
    },
    {
      headerName: "Field",
      field: "field",
      width: 200,
      cellRenderer: (params: any) => (
        <Tag color={params.value === "All" ? "green" : "red"}>{params.value}</Tag>
      ),
    },
    {
      headerName: "Initiator",
      field: "initiator",
      width: 200,
    },
    {
      headerName: "Created By",
      field: "created_by",
      width: 300,
    },
    {
      headerName: "Action",
      field: "action",
      width: 300,
      cellRenderer: () => (
        <Button type="default" shape="round" size="small" icon={<DownloadOutlined />}>
          Download
        </Button>
      ),
    },
  ];

  // ✅ Fetch function
const fetchData = async () => {
  try {
    const response = await axios.get("https://stage-apiplatform.finkraftai.com/api/vatTable/getHistory", {
      //moduleId: "VAT_TRANSACTIONS_DOWNLOAD",
    });

    const apiData = response.data?.data || [];

    // 🔹 Add hardcoded fields
    const enrichedData = apiData.map((item: any) => ({
      ...item,
      type: ["Transaction", "Application"], 
      field: "All",
      initiator: "Manual",
      created_by: "Ambuj Singh - 5:30AM",
    }));

    setRowData(enrichedData);
  } catch (error) {
  }
};


  // ✅ Fetch on mount
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <PageHeader title="PreviousExport"
       showWorkspaceDropdown={false}
       />
      <div style={{ flex: 1 }}>
        <AgTableClient
          //@ts-ignore
          columnDefs={COLUMN_DEFS}
          rowData={rowData}
          groupPanel
          defaultPivot={[""]}
          enablePDFViewer
        />
      </div>
    </>
  );
};

export default PreviousExport;









